import React from 'react';
import ProductFitQuizFullPage from './components/ProductFitQuizFullPage';

/**
 * The main application component.
 * It now directly renders the ProductFitQuizFullPage for a simple, embedded experience.
 */
export default function App() {
  return (
    <ProductFitQuizFullPage />
  );
}